/* GMD Activewear Australia - Build Your Own Loops Kit
   Reads live product data injected by sections/gmd-loops-builder.liquid.
   Nothing here hardcodes a price or a variant id. */
(function () {
  "use strict";

  var root = document.getElementById("gmdlb");
  var dataEl = document.getElementById("gmdlbData");
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* ---------- colour codes ----------
     The only hardcoded values in the builder. Loop colours come from GMD's
     size chart, bag colours from the loops bag product. Edit here if a
     colour is ever added or retired. */
  var HEX = {
    "grey": "#8E8E93", "white": "#FFFFFF", "gold": "#E8BC22", "red": "#D0021B",
    "purple": "#6B2D8B", "lime": "#A8D808", "lime green": "#A8D808",
    "pink": "#FF4FA3", "hot pink": "#FF2D87", "orange": "#F5821F",
    "royal": "#1B4FA0", "royal blue": "#1B4FA0", "turquoise": "#46B5F5",
    "bottle green": "#0B4D2C", "forest green": "#14502F",
    "seafoam mint": "#9FE2C0", "black": "#141419",
    "yellow": "#F5C400"
  };
  function hexFor(name) { return HEX[String(name).toLowerCase().trim()] || "#CCCCCC"; }

  /* ---------- GMD loops size chart ----------
     Loop size = wrist + 13. Half sizes and anything outside 23 to 33 are
     custom, made to order in black. */
  var WRIST_OFFSET = 13;
  function gloveForAny(cm) {
    if (cm <= 27) return "SML";
    if (cm <= 30) return "MED";
    return "LGE";
  }
  function isWhole(v) { return Math.abs(v - Math.round(v)) < 0.001; }

  /* ---------- parse live variants ---------- */
  function parseLoops(set) {
    if (!set) return null;
    var sizes = set.variants.map(function (v) {
      var m = /^(\d+(?:\.\d+)?)\s*cm\s+(.+)$/i.exec(v.title);
      if (m) {
        var colour = m[2].trim();
        return {
          id: v.id, sku: v.sku, price: v.price / 100, available: v.available,
          n: parseFloat(m[1]), cm: m[1] + "cm",
          colour: titleCase(colour), hex: hexFor(colour), custom: false
        };
      }
      var c = /black/i.test(v.title) ? "Black" : titleCase(v.title);
      return {
        id: v.id, sku: v.sku, price: v.price / 100, available: v.available,
        n: null, cm: "Custom", colour: c, hex: hexFor(c), custom: true
      };
    });
    return { label: set.label, desc: set.desc, sizes: sizes };
  }

  function titleCase(s) {
    return String(s).toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* Bag variants arrive as "Hot Pink / My name", "Hot Pink / My name + LOOPS"
     and "Hot Pink / Leave it plain" (option: "What goes on the bag?").
     Group by colour so each colour holds all three print options, each one
     pointing at its own real variant. Matching is on keywords, so small
     wording tweaks to the option values will not break it:
       contains "plain"  -> plain
       contains "loops"  -> name + LOOPS
       anything else     -> name only */
  function printKeyFor(opt) {
    opt = String(opt).toLowerCase();
    if (/plain/.test(opt)) return "plain";
    if (/loops/.test(opt)) return "nameloops";
    return "name";
  }

  function parseBags(set) {
    var byColour = {}, order = [];
    set.variants.forEach(function (v) {
      var parts = v.title.split("/");
      var colour = parts[0].trim();
      var opt = parts.slice(1).join("/").trim();
      if (!byColour[colour]) {
        byColour[colour] = { name: colour, hex: hexFor(colour), prints: {} };
        order.push(colour);
      }
      byColour[colour].prints[printKeyFor(opt)] = { id: v.id, price: v.price / 100, available: v.available };
    });
    return order.map(function (c) { return byColour[c]; });
  }

  var LOOPS = { standard: parseLoops(DATA.loops.standard) };
  if (DATA.loops.premium) LOOPS.premium = parseLoops(DATA.loops.premium);

  var BAGS = parseBags(DATA.bag);
  var GLOVES = DATA.gloves.variants.map(function (v) {
    return { id: v.id, size: v.title.trim(), price: v.price / 100, available: v.available };
  });

  var PRINTS = [
    { key: "name", label: "My name" },
    { key: "nameloops", label: "My name + LOOPS" },
    { key: "plain", label: "Leave it plain" }
  ];
  var METHODS = [
    { key: "wrist", label: "Measure the wrist", lbl: "Wrist circumference in cm", ph: "e.g. 15", min: 6, max: 32 },
    { key: "loops", label: "Measure loops I have", lbl: "Loop length in cm, laid flat", ph: "e.g. 28", min: 18, max: 48 }
  ];

  /* ---------- state ---------- */
  var state = {
    type: "standard", size: null, customCm: "",
    bag: null, print: "name", bagName: "", glove: null,
    method: "wrist", found: null, busy: false, added: false
  };

  function $(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s).replace(/[<>&"]/g, function (c) {
      return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c];
    });
  }
  function money(n) {
    var cents = Math.round(n * 100);
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, DATA.moneyFormat);
    return "$" + n.toFixed(2);
  }
  function needsName() { return state.print === "name" || state.print === "nameloops"; }
  /* The bag variant for the chosen colour and print option. */
  function bagSlot(b) { b = b || state.bag; return (b && b.prints[state.print]) || null; }
  function bagPrice() { var s = bagSlot(); return s ? s.price : 0; }
  function bagVariant() { var s = bagSlot(); return s ? s.id : null; }
  function method() { return METHODS.filter(function (m) { return m.key === state.method; })[0]; }

  /* ---------- render ---------- */
  function renderTypes() {
    $("gmdlbTypes").innerHTML = Object.keys(LOOPS).map(function (k) {
      var t = LOOPS[k];
      var from = Math.min.apply(null, t.sizes.map(function (s) { return s.price; }));
      return '<button class="gmdlb-type" type="button" data-type="' + k + '" aria-pressed="' + (state.type === k) + '">' +
        '<span class="gmdlb-tname">' + esc(t.label) + '<span class="gmdlb-tprice">' + money(from) + '</span></span>' +
        '<span class="gmdlb-tdesc">' + esc(t.desc || "") + '</span></button>';
    }).join("");
  }

  function renderSizes() {
    var set = LOOPS[state.type];
    $("gmdlbPremNote").classList.toggle("gmdlb-hidden", state.type !== "premium");
    $("gmdlbSizes").innerHTML = set.sizes.map(function (s) {
      var on = state.size && state.size.id === s.id;
      var off = !s.available;
      return '<button class="gmdlb-size' + (s.custom ? " gmdlb-custom" : "") + '" type="button" data-sku="' + s.id +
        '" aria-pressed="' + on + '"' + (off ? ' disabled aria-disabled="true"' : "") + '>' +
        (off ? '<span class="gmdlb-out">Sold out</span>' : "") +
        '<span class="gmdlb-tick">&#10003;</span>' +
        '<span class="gmdlb-swatch" style="' + (s.custom ? "" : "background:" + s.hex) + '"></span>' +
        '<span class="gmdlb-cm">' + (s.custom ? "Custom" : s.cm.replace("cm", "")) + '</span>' +
        '<span class="gmdlb-cname">' + esc(s.colour) + '</span></button>';
    }).join("");
  }

  /* A bag colour is only selectable if the variant for the chosen print
     option exists and is available. A missing variant blocks the add
     instead of sending an empty id to the cart. */
  function bagAvailable(b) {
    var s = bagSlot(b);
    return !!s && s.available !== false;
  }

  function renderBags() {
    $("gmdlbBags").innerHTML = BAGS.map(function (b) {
      var on = state.bag && state.bag.name === b.name;
      var off = !bagAvailable(b);
      return '<button class="gmdlb-bag" type="button" data-bag="' + esc(b.name) + '" aria-pressed="' + on + '"' +
        (off ? ' disabled aria-disabled="true"' : "") + '>' +
        (off ? '<span class="gmdlb-out">Sold out</span>' : "") +
        '<span class="gmdlb-tick">&#10003;</span>' +
        '<span class="gmdlb-swatch" style="background:' + b.hex + '"></span>' +
        '<span class="gmdlb-cname">' + esc(b.name) + '</span></button>';
    }).join("");
  }

  function renderPrints() {
    $("gmdlbPrints").innerHTML = PRINTS.map(function (p) {
      return '<button class="gmdlb-pill" type="button" data-print="' + p.key + '" aria-pressed="' +
        (state.print === p.key) + '">' + p.label + '</button>';
    }).join("");
    $("gmdlbNameField").classList.toggle("gmdlb-hidden", !needsName());
  }

  function renderGloves() {
    var rec = null;
    if (state.size && !state.size.custom) rec = gloveForAny(state.size.n);
    else if (state.size && state.size.custom && state.customCm) {
      var cc = parseFloat(state.customCm);
      if (!isNaN(cc)) rec = gloveForAny(cc);
    }
    $("gmdlbGloves").innerHTML = GLOVES.map(function (g) {
      var on = state.glove && state.glove.size === g.size;
      var off = !g.available;
      return '<button class="gmdlb-pill" type="button" data-glove="' + esc(g.size) + '" aria-pressed="' + on + '"' +
        (off ? ' disabled aria-disabled="true"' : "") + '>' + esc(g.size) +
        (off ? '<span class="gmdlb-sub">Sold out</span>'
             : (rec === g.size ? '<span class="gmdlb-rec">We suggest</span>' : "")) + '</button>';
    }).join("");
  }

  function renderMethods() {
    $("gmdlbMethods").innerHTML = METHODS.map(function (m) {
      return '<button class="gmdlb-pill" type="button" data-method="' + m.key + '" aria-pressed="' +
        (state.method === m.key) + '">' + m.label + '</button>';
    }).join("");
    $("gmdlbMeasureLabel").textContent = method().lbl;
    $("gmdlbMeasure").placeholder = method().ph;
  }

  /* ---------- summary ---------- */
  function complete() {
    if (!state.size || !state.bag || !state.glove) return false;
    if (!state.size.available || !state.glove.available || !bagAvailable(state.bag)) return false;
    if (state.size.custom && !state.customCm.trim()) return false;
    if (needsName() && !state.bagName.trim()) return false;
    return true;
  }

  function printLabel() {
    var nm = state.bagName.trim() || "?";
    if (state.print === "name") return nm;
    if (state.print === "nameloops") return nm + " + LOOPS";
    return "Plain";
  }

  function update() {
    var set = LOOPS[state.type];

    if (state.size) {
      $("gmdlbPvLoop").style.background = state.size.hex;
      $("gmdlbPvLoopVal").textContent = state.size.custom
        ? (state.customCm ? state.customCm + "cm Black" : "Custom Black")
        : state.size.cm + " " + state.size.colour;
    } else {
      $("gmdlbPvLoop").style.background = "";
      $("gmdlbPvLoopVal").textContent = "Not chosen";
    }

    if (state.bag) {
      $("gmdlbPvBag").style.background = state.bag.hex;
      $("gmdlbPvBagVal").textContent = state.bag.name;
    } else {
      $("gmdlbPvBag").style.background = "";
      $("gmdlbPvBagVal").textContent = "Not chosen";
    }

    var rows = [];
    rows.push(state.size
      ? { n: set.label, m: (state.size.custom ? "Custom " + (state.customCm || "?") + "cm, Black" : state.size.cm + " " + state.size.colour.toUpperCase()), p: state.size.price }
      : { n: "Bar loops", m: "Choose a type and size", p: null });
    rows.push(state.bag
      ? { n: DATA.bag.label, m: state.bag.name.toUpperCase() + " / " + printLabel().toUpperCase(), p: bagPrice() }
      : { n: "Loops bag", m: "Choose a colour", p: null });
    rows.push(state.glove
      ? { n: DATA.gloves.label, m: state.glove.size, p: state.glove.price }
      : { n: "White gloves", m: "Choose a size", p: null });

    $("gmdlbLines").innerHTML = rows.map(function (r) {
      return '<div class="gmdlb-line' + (r.p === null ? " gmdlb-empty" : "") + '"><span>' +
        '<span class="gmdlb-lname">' + esc(r.n) + '</span>' +
        '<span class="gmdlb-lmeta">' + esc(r.m) + '</span></span>' +
        '<span class="gmdlb-lprice">' + (r.p === null ? "" : money(r.p)) + '</span></div>';
    }).join("");

    var total = (state.size ? state.size.price : 0) +
                (state.bag ? bagPrice() : 0) +
                (state.glove ? state.glove.price : 0);

    $("gmdlbTotal").textContent = money(total);
    $("gmdlbMTotal").textContent = money(total);
    $("gmdlbCompare").innerHTML = complete()
      ? "Same price as our ready made kits, in the colours you choose." : "";

    var ok = complete() && !state.busy && !state.added;
    $("gmdlbAdd").disabled = !ok;
    $("gmdlbMAdd").disabled = !ok;
    var label = state.busy ? "Adding..." : (state.added ? "✓ Added to cart" : "Add kit to cart");
    $("gmdlbAdd").textContent = label;
    $("gmdlbMAdd").textContent = state.busy ? "Adding..." : (state.added ? "✓ Added" : "Add to cart");

    var bits = [];
    if (state.size) bits.push(state.size.custom ? "Custom " + (state.customCm || "?") + "cm" : state.size.cm + " " + state.size.colour);
    if (state.bag) bits.push(state.bag.name + " bag");
    if (state.glove) bits.push(state.glove.size + " gloves");
    $("gmdlbMSub").textContent = bits.length ? bits.join(", ") : "Start building your kit";
  }

  /* ---------- size finder ---------- */
  function finderError(msg) {
    var box = $("gmdlbFinderResult");
    box.classList.remove("gmdlb-hidden");
    box.innerHTML = '<div class="gmdlb-ftext"><div class="gmdlb-fbig">That does not look right</div>' +
      '<div class="gmdlb-fsub">' + esc(msg) + '</div></div>';
  }

  function runFinder() {
    var m = method(), raw = parseFloat($("gmdlbMeasure").value), box = $("gmdlbFinderResult");
    if (isNaN(raw) || raw < m.min || raw > m.max) {
      finderError("Enter a measurement in centimetres between " + m.min + " and " + m.max + ".");
      return;
    }
    var loopCm = state.method === "wrist" ? raw + WRIST_OFFSET : raw;
    var glove = gloveForAny(loopCm);
    var set = LOOPS[state.type];
    var listed = isWhole(loopCm) && loopCm >= 23 && loopCm <= 33;

    if (listed) {
      var match = set.sizes.filter(function (s) { return s.n === loopCm; })[0];
      if (!match) {
        /* Premium stocks 25cm to 32cm. Every other size is still available in
           premium as a custom pair, made to order in black. Never push the
           customer back to Standard. */
        state.found = { custom: true, loopCm: loopCm, glove: glove };
        box.classList.remove("gmdlb-hidden");
        box.innerHTML = '<span class="gmdlb-fchip gmdlb-fchipcustom"></span>' +
          '<div class="gmdlb-ftext"><div class="gmdlb-fbig">Custom ' + loopCm + 'cm</div>' +
          '<div class="gmdlb-fsub">Not a stock premium size. Made to order in black, with ' + glove + ' gloves. Allow about a week.</div></div>' +
          '<button class="gmdlb-fapply" type="button" id="gmdlbApply">Use these</button>';
        return;
      }
      if (!match.available) {
        state.found = null;
        box.classList.remove("gmdlb-hidden");
        box.innerHTML = '<div class="gmdlb-ftext"><div class="gmdlb-fbig">' + match.cm + " " + esc(match.colour) + '</div>' +
          '<div class="gmdlb-fsub">That size is sold out right now. Contact us and we can let you know when it is back.</div></div>';
        return;
      }
      state.found = { custom: false, loopCm: loopCm, glove: glove };
      box.classList.remove("gmdlb-hidden");
      box.innerHTML = '<span class="gmdlb-fchip" style="background:' + match.hex + '"></span>' +
        '<div class="gmdlb-ftext"><div class="gmdlb-fbig">' + match.cm + " " + esc(match.colour) + '</div>' +
        '<div class="gmdlb-fsub">With ' + glove + ' gloves</div></div>' +
        '<button class="gmdlb-fapply" type="button" id="gmdlbApply">Use these</button>';
      return;
    }

    state.found = { custom: true, loopCm: loopCm, glove: glove };
    box.classList.remove("gmdlb-hidden");
    box.innerHTML = '<span class="gmdlb-fchip gmdlb-fchipcustom"></span>' +
      '<div class="gmdlb-ftext"><div class="gmdlb-fbig">Custom ' + loopCm + 'cm</div>' +
      '<div class="gmdlb-fsub">Made to order in black, with ' + glove + ' gloves. Allow about a week.</div></div>' +
      '<button class="gmdlb-fapply" type="button" id="gmdlbApply">Use these</button>';
  }

  function applyFind() {
    if (!state.found) return;
    var set = LOOPS[state.type];
    if (state.found.custom) {
      state.size = set.sizes.filter(function (s) { return s.custom; })[0];
      state.customCm = String(state.found.loopCm);
      $("gmdlbCustomCm").value = state.customCm;
      $("gmdlbCustomField").classList.remove("gmdlb-hidden");
      $("gmdlbCustomFlag").classList.remove("gmdlb-hidden");
    } else {
      state.size = set.sizes.filter(function (s) { return s.n === state.found.loopCm; })[0];
      state.customCm = "";
      $("gmdlbCustomField").classList.add("gmdlb-hidden");
      $("gmdlbCustomFlag").classList.add("gmdlb-hidden");
    }
    state.glove = GLOVES.filter(function (g) { return g.size === state.found.glove; })[0] || state.glove;
    $("gmdlbFinder").classList.add("gmdlb-hidden");
    $("gmdlbFinderToggle").textContent = "Not sure of your size? Find it here";
    renderSizes(); renderGloves(); update();
    $("gmdlbSizes").scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /* Open the theme's cart drawer after adding.
     Apollo, like most themes, listens for a cart refresh event and opens its
     drawer when its cart trigger is clicked. We try the common patterns in
     order and fall back to the cart page if none of them exist.

     IF THE DRAWER DOES NOT OPEN: add your theme's own trigger selector as the
     first entry in TRIGGERS below. Inspect the cart icon in your header and
     copy its class or data attribute. */
  var TRIGGERS = [
    "[data-cart-drawer-toggle]",
    "[data-drawer-toggle='cart']",
    ".js-drawer-open-cart",
    "[data-action='open-cart']",
    ".header__shopping-cart",
    ".site-header__cart",
    "a[href='/cart']"
  ];

  function notifyTheme() {
    ["cart:refresh", "cart:build", "cart:updated", "ajaxProduct:added"].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    document.dispatchEvent(new CustomEvent("gmdlb:added", { bubbles: true }));
  }

  function openCartDrawer() {
    notifyTheme();
    for (var i = 0; i < TRIGGERS.length; i++) {
      var el = document.querySelector(TRIGGERS[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  var addedBox = document.createElement("div");
  addedBox.className = "gmdlb-added gmdlb-hidden";
  addedBox.id = "gmdlbAdded";
  $("gmdlbAdd").parentNode.appendChild(addedBox);

  function showAdded() {
    state.added = true;
    var bits = [];
    bits.push(state.size.custom ? "Custom " + state.customCm + "cm loops" : state.size.cm + " " + state.size.colour + " loops");
    bits.push(state.bag.name + " bag" + (needsName() ? " (" + printLabel() + ")" : ""));
    bits.push(state.glove.size + " gloves");
    addedBox.innerHTML =
      '<div class="gmdlb-addedhead">&#10003; Added to your cart</div>' +
      (state.lastKit ? '<div class="gmdlb-addedkit">' + esc(state.lastKit) + '</div>' : "") +
      '<ul class="gmdlb-addedlist"><li>' + bits.map(esc).join("</li><li>") + '</li></ul>' +
      '<a class="gmdlb-addedcart" href="/cart">View cart and check out</a>' +
      '<button class="gmdlb-addedmore" type="button" id="gmdlbAnother">Build another kit</button>';
    addedBox.classList.remove("gmdlb-hidden");
    update();
    addedBox.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function clearAdded() {
    if (!state.added) return;
    state.added = false;
    addedBox.classList.add("gmdlb-hidden");
  }

  /* ---------- add to cart ---------- */
  /* Work out which kit number this is, by reading the kit labels already
     in the cart. Gives the warehouse "Kit 1", "Kit 2" and so on rather than
     a hidden id nobody can see on a packing slip. */
  function nextKitNumber() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var highest = 0;
        (cart.items || []).forEach(function (item) {
          var label = item.properties && item.properties["Kit"];
          var m = label && /^Kit\s+(\d+)/.exec(String(label));
          if (m) highest = Math.max(highest, parseInt(m[1], 10));
        });
        return highest + 1;
      })
      .catch(function () { return 1; });
  }

  /* One label, repeated on all three lines, naming the whole kit.
     e.g. "Kit 2: Ava / 29cm Pink" */
  function kitLabel(n) {
    var who = needsName() ? state.bagName.trim() : "no name";
    var loops = state.size.custom
      ? "Custom " + state.customCm + "cm"
      : state.size.cm + " " + state.size.colour;
    return "Kit " + n + ": " + who + " / " + loops;
  }

  function addToCart() {
    if (!complete() || state.busy || state.added) return;
    state.busy = true; update();
    $("gmdlbErr").classList.add("gmdlb-hidden");

    nextKitNumber().then(function (n) { return postKit(n); });
  }

  function postKit(kitNo) {
    var bid = "loops-kit-" + Date.now().toString(36);
    var kit = kitLabel(kitNo);
    state.lastKit = kit;

    var loopProps = { _bundle: bid, Kit: kit, "Kit item": "1 of 3 - Bar loops" };
    if (state.size.custom) loopProps["Custom size"] = state.customCm + "cm";

    var bagProps = { _bundle: bid, Kit: kit, "Kit item": "2 of 3 - Loops bag", Print: printLabel() };

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          { id: state.size.id, quantity: 1, properties: loopProps },
          { id: bagVariant(), quantity: 1, properties: bagProps },
          { id: state.glove.id, quantity: 1, properties: { _bundle: bid, Kit: kit, "Kit item": "3 of 3 - White gloves" } }
        ]
      })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : "Could not add to cart");
        if (DATA.cartRedirect) { window.location.href = "/cart"; return; }
        state.busy = false;
        showAdded();          // our own confirmation, always
        try { openCartDrawer(); } catch (e) {}   // drawer is a bonus, not the signal
      })
      .catch(function (err) {
        state.busy = false; update();
        var e = $("gmdlbErr");
        e.textContent = err.message + ". Please try again, or contact us and we will sort it out.";
        e.classList.remove("gmdlb-hidden");
      });
  }

  /* ---------- events ---------- */
  root.addEventListener("click", handleClick);
  $("gmdlbMobar").addEventListener("click", handleClick);

  function handleClick(e) {
    clearAdded();
    var t = e.target.closest("[data-type]");
    if (t) {
      var prev = state.size;
      state.type = t.dataset.type;
      var set = LOOPS[state.type], sf = $("gmdlbSwitchFlag");
      sf.classList.add("gmdlb-hidden");
      if (prev && prev.custom) {
        state.size = set.sizes.filter(function (s) { return s.custom; })[0];
      } else if (prev) {
        var carried = set.sizes.filter(function (s) { return s.n === prev.n; })[0];
        if (carried) { state.size = carried; }
        else {
          state.size = null; state.customCm = "";
          $("gmdlbCustomField").classList.add("gmdlb-hidden");
          $("gmdlbCustomFlag").classList.add("gmdlb-hidden");
          sf.innerHTML = '<span>&#9432;</span><span>' + esc(set.label) + ' does not come in <b>' +
            prev.cm + " " + esc(prev.colour) + '</b>. Pick another size, or order it as a custom size in black.</span>';
          sf.classList.remove("gmdlb-hidden");
        }
      }
      renderTypes(); renderSizes(); renderGloves(); update(); return;
    }

    clearAdded();
    var s = e.target.closest("[data-sku]");
    if (s) {
      state.size = LOOPS[state.type].sizes.filter(function (x) { return String(x.id) === s.dataset.sku; })[0];
      $("gmdlbCustomField").classList.toggle("gmdlb-hidden", !state.size.custom);
      $("gmdlbCustomFlag").classList.toggle("gmdlb-hidden", !state.size.custom);
      if (!state.size.custom) state.customCm = "";
      $("gmdlbSwitchFlag").classList.add("gmdlb-hidden");
      renderSizes(); renderGloves(); update(); return;
    }

    clearAdded();
    var b = e.target.closest("[data-bag]");
    if (b) { state.bag = BAGS.filter(function (x) { return x.name === b.dataset.bag; })[0]; renderBags(); update(); return; }

    clearAdded();
    var p = e.target.closest("[data-print]");
    if (p) {
      state.print = p.dataset.print;
      if (!needsName()) { state.bagName = ""; $("gmdlbBagName").value = ""; }
      if (state.bag && !bagAvailable(state.bag)) state.bag = null;
      renderPrints(); renderBags(); update(); return;
    }

    clearAdded();
    var g = e.target.closest("[data-glove]");
    if (g) { state.glove = GLOVES.filter(function (x) { return x.size === g.dataset.glove; })[0]; renderGloves(); update(); return; }

    var mm = e.target.closest("[data-method]");
    if (mm) {
      state.method = mm.dataset.method; state.found = null;
      $("gmdlbMeasure").value = "";
      $("gmdlbFinderResult").classList.add("gmdlb-hidden");
      renderMethods(); $("gmdlbMeasure").focus(); return;
    }

    if (e.target.id === "gmdlbAnother") { clearAdded(); update(); return; }
    if (e.target.id === "gmdlbApply") { applyFind(); return; }
    if (e.target.id === "gmdlbAdd" || e.target.id === "gmdlbMAdd") { addToCart(); return; }
  }

  $("gmdlbFinderToggle").addEventListener("click", function () {
    var hidden = $("gmdlbFinder").classList.toggle("gmdlb-hidden");
    this.textContent = hidden ? "Not sure of your size? Find it here" : "Close the size finder";
    if (!hidden) $("gmdlbMeasure").focus();
  });
  $("gmdlbFinderGo").addEventListener("click", runFinder);
  $("gmdlbMeasure").addEventListener("keydown", function (e) { if (e.key === "Enter") runFinder(); });
  $("gmdlbCustomCm").addEventListener("input", function (e) { clearAdded(); state.customCm = e.target.value; renderGloves(); update(); });
  $("gmdlbBagName").addEventListener("input", function (e) { clearAdded(); state.bagName = e.target.value; update(); });

  $("gmdlbCustomCm").placeholder = "e.g. 27.5";
  renderTypes(); renderSizes(); renderBags(); renderPrints(); renderGloves(); renderMethods(); update();
})();